import { createCommand } from '../../utils';
import { displayRoads, moduleName } from '../state';
import { userOrganizationQuery } from '../../authentication/queries';

type Args = {
    display: boolean;
};

export const UpdateDisplayRoadsCommand = createCommand(
    `${moduleName}/UPDATE_DISPLAY_ROADS`,
    async ({ display }: Args, { dispatch, extra, getState }) => {
        const userOrganization = userOrganizationQuery(getState());

        if (userOrganization) {
            await extra.mapViewSettings.updateDisplayRoadsForOrganization(userOrganization.id, display);
        }

        dispatch(displayRoads(display));
    },
);
